import styled from 'styled-components';
export var Container = styled.div.withConfig({
  displayName: "ValueModestyles__Container",
  componentId: "keen-widget-settings__sc-1zlp-0"
})(["&&&{display:flex;flex-direction:column;}"]);
export var ValueModeContainer = styled.div.withConfig({
  displayName: "ValueModestyles__ValueModeContainer",
  componentId: "keen-widget-settings__sc-1zlp-1"
})(["&&&{min-width:200px;}"]);